import { isDesktop } from "../../services/service-utils";
export function receiptQuizFunction(Quiz, json) {
  let quizQuestions = Quiz.querySelectorAll("input[type=radio]");
  if (quizQuestions) {
    //add an eventlistener to each question if the user clicks on it and the answer is wrong then show the error message
    quizQuestions.forEach((question) => {
      question.addEventListener("click", (e) => {
        if (e.target.value == "false") {
          e.target.parentElement.parentElement.parentElement.parentElement.querySelector("[data-false]").classList.remove("invisible");
        } else {
          e.target.parentElement.parentElement.parentElement.parentElement.querySelector("[data-false]").classList.add("invisible");
          //find the ancestor element with class quiz-slide
          let ancestor = e.target.closest(".quiz-slide");
          let quizInner = ancestor.parentElement;

          // if ancestor is not the last element in the quiz, translateX the guide-quiz-inner to the next question in quide-quiz-outer
          if (ancestor.nextElementSibling) {
            //if desktop
            if (ancestor.previousElementSibling && isDesktop()) {
              let slidePosition = ancestor.dataset.index === "1" ? ancestor.offsetLeft - 80 : ancestor.offsetLeft;
              quizInner.style.transform = `translateX(calc(-${slidePosition}px))`;
            }
            //if mobile
            if (!isDesktop()) {
              let slidePosition = ancestor.dataset.index === "0" ? ancestor.nextElementSibling.offsetLeft - 20 : ancestor.nextElementSibling.offsetLeft;
              quizInner.style.transform = `translateX(calc(-${slidePosition}px))`;
            }

            //remove the class slide-active from the current question and add it to the next question
            ancestor.classList.remove("slide-active");
            ancestor.nextElementSibling.classList.add("slide-active");
          }
        }
      });
    });
  }
}
